import { Grid } from '@mui/material';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { checkRequired } from '@/helpers/defect-form';
import { SelectOptions } from '@/types/interfaces/form';
import FormAutocomplete from '../../Common/Form/FormAutocomplete';
import { DynamicFormValues } from '../DefectDetails';

interface ColorFormProps {
  control: Control<DynamicFormValues>;
  selectOptions: SelectOptions;
  disabled: boolean;
  isRequired?: boolean;
}

const ColorForm = ({
  control,
  selectOptions,
  disabled,
  isRequired,
}: ColorFormProps) => {
  const { t } = useTranslation();

  const required = isRequired ? t('QC_V2.DEFECT.REQUIRED') : undefined;

  const isHidden = !selectOptions.colors.length;

  if (isHidden) return null;

  return (
    <Grid item xs={12}>
      <FormAutocomplete
        data-testid="color_combobox"
        control={control}
        name="color"
        label={t('QC_V2.DEFECT.COLOR')}
        rules={{
          required: checkRequired(required, selectOptions.colors),
        }}
        autocompleteProps={{
          options: selectOptions.colors,
          disabled: disabled,
          isOptionEqualToValue: (option, value) => option.value === value.value,
        }}
      />
    </Grid>
  );
};

export default ColorForm;
